module.exports = __webpack_public_path__ + "img/farzana-christopher-79.20bcd819.jpg";